import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import moment from 'moment'
import { withRouter } from 'react-router-dom'

import useGetPointsOfSales from 'core/hooks/useGetPointsOfSales'
import useGetConfig from 'core/hooks/useGetConfig'
import * as routes from 'core/routing/constants/index'
import PageLoading from 'core/components/page-loading'
import wizardsShape from 'core/components/wizard/shapes'
import RequesterTradeIn, { RequesterTradeInMethods } from 'core/requesters/RequesterTradeIn'

import { fontFamily } from 'assets/themes/theme-default'

import configurationShape from './shapes'
import { tradeInShape } from '../trade-in/shapes'

const Configuration = props => {
  const {
    location,
    history,
    match,
    configuration,
    setConfiguration,
    setPointOfSales,
    resetTradeIn,
    resetConfiguration,
    getLang,
    wizards,
    setWizards,
    resetLayout
  } = props

  const { getPointsOfSales } = useGetPointsOfSales({})
  const { pathname } = location
  const urlParams = new URL(window.location.href).searchParams
  const urlReturn = urlParams.get('urlReturn') || null
  const labelUrlReturn = urlParams.get('labelUrlReturn') || null

  const { hasError, config, getConfig, releaseId } = useGetConfig(pathname)

  const { params } = match
  const { tokenCampaign, color1, color2, isGlobal } = params

  useEffect(() => {
    if (hasError) history.push(routes.ERROR)
  }, [hasError])

  useEffect(() => {
    const runIt = async configurationWS => {
      const {
        campaign,
        providerConfiguration,
        privacyPolicy,
        opportunitySettings,
        applicationOptions,
        currentPricingPolicy,
        automaticValidationSetting
      } = configurationWS

      resetLayout()
      const newConfig = {
        ...configuration,
        campaign,
        providerConfiguration,
        privacyPolicy,
        opportunitySettings,
        applicationOptions,
        urlReturn,
        labelUrlReturn,
        currentPricingPolicy,
        automaticValidationSetting
      }

      const makeId = urlParams.get('makeId') || null
      const dealerCode = urlParams.get('dealerCode') || null

      const { theme, lang } = campaign

      // Set Lang
      getLang(lang)

      // set Theme
      if (theme) newConfig.theme = theme

      // If theming
      if (color1 && color2) {
        newConfig.theme = {
          colors: {
            color1: {
              bg: `#${color1}`
            },
            color2: {
              bg: `#${color2}`
            }
          },
          fontFamily: fontFamily.font
        }

        setConfiguration(newConfig)

        localStorage.setItem('config', 'theming')

        history.push(routes.THEMING)
      }
      // Normal mode
      else {
        // Check if campaign is active
        const { beginDate, endDate } = campaign

        const isActiveCampaign = endDate
          ? moment().isBetween(beginDate, endDate)
          : moment().isAfter(beginDate)

        if (!isActiveCampaign) {
          history.push(routes.INACTIVE_CAMPAIGN)
        } else {
          if (makeId && dealerCode) {
            resetTradeIn()
            const pointOfSales = await getPointsOfSales({ makeId, dealerCode })
            if (pointOfSales && pointOfSales.length === 1) {
              setPointOfSales({
                pointOfSales: pointOfSales[0],
                makeId,
                dealerCode
              })
            }
          } else {
            resetTradeIn()
          }
          await setConfiguration(newConfig)
          //localStorage.setItem('isGlobalDealer', 'global dealer bearer')
          // TO DO
          // if set => access stock & configurator, if not => access trade in only
          if (isGlobal && isGlobal === '1')
            localStorage.setItem('isGlobalDealer', 'global dealer bearer')
          else {
            const extendedWizard = { ...wizards, previousWizard: null }
            setWizards(extendedWizard)
          }
          // Config of the app
          localStorage.setItem('config', 'global dealer config')

          if (
            releaseId !== undefined &&
            releaseId &&
            releaseId !== process.env.REACT_APP_RELEASE_ID
          ) {
            // console.log("reload wrong releaseId")
            window.location.reload()
          }

          if (urlParams.get('context')) {
            await RequesterTradeIn.get(
              RequesterTradeInMethods.GET_STORED_CONTEXT,
              { uuid: urlParams.get('context') },
              ''
            )
              .then(async datas => {
                if (datas.tradeIn) {
                  await setConfiguration({
                    ...newConfig,
                    tradeInContext: { ...datas.tradeIn, loading: true }
                  })
                }
              })
              .catch(() => {
                history.push(routes.HOME)
              })
          }

          await history.push(routes.HOME)
        }
      }
    }

    if (config) {
      runIt(config)
    }
  }, [config, releaseId])

  useEffect(() => {
    localStorage.clear()
    resetConfiguration()
    getConfig({ token: tokenCampaign })
  }, [])

  return <PageLoading />
}

Configuration.propTypes = {
  location: PropTypes.shape().isRequired,
  wizards: wizardsShape.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  configuration: configurationShape.isRequired,
  tradeIn: tradeInShape.isRequired,
  setWizards: PropTypes.func.isRequired,
  setConfiguration: PropTypes.func.isRequired,
  resetConfiguration: PropTypes.func.isRequired,
  resetTradeIn: PropTypes.func.isRequired,
  getLang: PropTypes.func.isRequired,
  resetLayout: PropTypes.func.isRequired,
  setPointOfSales: PropTypes.func.isRequired
}

export default withRouter(Configuration)
